import React, { useEffect } from "react";
import { Formik, Form } from "formik";
import { TextInputComponent } from "../../../../../common/components";
import './annual-revenue-filter.scss';

const AnnualRevenueFilter: any = (
  props: any
) => {
  const { annualRevenueRange, handleAnnualRevenueChange, isAnnualRevenueEnabled, minValueError, maxValueError } = props
  useEffect(() => {
    if (!isAnnualRevenueEnabled) {
      handleAnnualRevenueChange({ target: { value: "", name: "min" } } as any, "min");
      handleAnnualRevenueChange({ target: { value: "", name: "max" } } as any, "max");
    }
  }, [isAnnualRevenueEnabled]);
  return (
    <div className="annual-revenue-filter-wrapper">
      <Formik
        initialValues={{
          min: annualRevenueRange.min,
          max: annualRevenueRange.max,
        }}
        enableReinitialize
        onSubmit={(values) => {
          console.log("Form Submitted with values:", values);
        }}
      >
        <Form className="annual-revenue-filter">
          <div className="text-inputs">
            <div className="form-group">
              <TextInputComponent
                type="text"
                isNumber
                fieldName="min"
                placeholder="Enter Min Value"
                optional={false}
                disabled={false}
                value={annualRevenueRange.min}
                onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
                  handleAnnualRevenueChange(e, "min")
                }
                blockInvalidChars={true}
              />
              {props.minValueError && (
                <span className="error-text">{props.minValueError}</span>
              )}
            </div>

            <div className="form-group">
              <TextInputComponent
                type="text"
                isNumber
                fieldName="max"
                placeholder="Enter Max Value"
                optional={false}
                disabled={false}
                value={annualRevenueRange.max}
                onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
                  handleAnnualRevenueChange(e, "max")
                }
                blockInvalidChars={true}
              />
              {props.maxValueError && (
                <span className="error-text">{props.maxValueError}</span>
              )}
            </div>
          </div>

        </Form>
      </Formik>
    </div>

  );
};
export default AnnualRevenueFilter;